import React from 'react';
import styled from 'styled-components';

import { type BankAccountWithDetails } from '@column/api';

type SearchMetadata = NonNullable<BankAccountWithDetails['search_metadata']>;

const MatchedText = styled.span`
  color: ${({ theme }) => theme.primary.background};
  font-weight: bold;
`;

export const renderHighlight = (text: string) => {
  const parts = text.split(/(<em>.*?<\/em>)/g);
  return (
    <span>
      {parts.map((part, i) => {
        const match = part.match(/^<em>(.*?)<\/em>$/);
        if (match) {
          return <MatchedText key={i}>{match[1]}</MatchedText>;
        }
        return part;
      })}
    </span>
  );
};

export const getHighlightedField = (
  searchMetadata: SearchMetadata | undefined,
  ...fields: string[]
): string | undefined => {
  const highlights =
    searchMetadata && typeof searchMetadata === 'object' && 'highlights' in searchMetadata
      ? (searchMetadata as { highlights?: Record<string, string[]> }).highlights
      : undefined;
  if (!highlights) return undefined;
  for (const field of fields) {
    const fragments = highlights[field];
    if (fragments?.length) return fragments[0];
  }
  return undefined;
};
